import { CustomerBagScanPage } from '@/pages/scan';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/scan')({
	component: CustomerBagScanPage,
});
